/* ============================================================
   NIDO — JavaScript propio (vanilla, sin librerías)
   Una función init por componente; cada una comprueba que su
   elemento existe antes de actuar, así el archivo sirve para
   todas las páginas.
   ============================================================ */
(function () {
  "use strict";

  // El archivo puede incluirse desde varias secciones: ejecútalo una sola vez.
  if (window.__nidoInit) return;
  window.__nidoInit = true;

  // Marca de que el JS está vivo: el CSS solo oculta para animar si existe.
  document.documentElement.classList.add("mt-js");

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function revealAll() {
    document.querySelectorAll(".mt-reveal").forEach(function (el) {
      el.classList.add("mt-visible");
    });
  }

  /* ---------- Reveal al hacer scroll ---------- */
  function initReveal() {
    var items = document.querySelectorAll(".mt-reveal");
    if (!items.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      revealAll();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("mt-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    items.forEach(function (el) { io.observe(el); });

    // Salvavidas: si por lo que sea el observador no dispara (pestaña en
    // segundo plano, motores raros), nada debe quedarse invisible.
    setTimeout(revealAll, 2600);
    window.addEventListener("load", function () { setTimeout(revealAll, 1200); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initHeroParallax() {
    var img = document.querySelector(".mt-hero__media img");
    if (!img || reduce) return;
    var ticking = false;
    function update() {
      var r = img.getBoundingClientRect();
      var offset = (r.top + r.height / 2 - window.innerHeight / 2) * -0.06;
      img.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0) scale(1.08)";
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Galería de la página de producto ---------- */
  function initGaleria() {
    var galeria = document.querySelector("[data-mt-galeria]");
    if (!galeria) return;
    var principal = galeria.querySelector("[data-mt-principal]");
    var minis = galeria.querySelectorAll("[data-mt-mini]");
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener("click", function () {
        var full = mini.getAttribute("data-full");
        var alt = mini.getAttribute("data-alt") || "";
        if (full) { principal.src = full; principal.alt = alt; }
        minis.forEach(function (m) { m.classList.remove("is-activa"); });
        mini.classList.add("is-activa");
      });
    });
  }

  /* ---------- Selector de variantes (solo si hay más de una) ---------- */
  function initVariantes() {
    var raiz = document.querySelector("[data-mt-variantes]");
    if (!raiz) return;
    var datos = document.querySelector("[data-mt-variant-json]");
    if (!datos) return;
    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    var selects = raiz.querySelectorAll("[data-mt-opcion]");
    var inputId = raiz.querySelector("[data-mt-variant-id]");
    var precioEl = raiz.querySelector("[data-mt-precio]");
    var boton = raiz.querySelector("[data-mt-add]");
    var money = raiz.getAttribute("data-money") || "{{amount}}";

    function formatea(cents) {
      var v = (cents / 100).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return money.replace("{{amount}}", v).replace("${{amount}}", "$" + v);
    }
    function actualiza() {
      var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = variantes.find(function (x) {
        return x.options.every(function (op, i) { return op === elegidas[i]; });
      });
      if (!v) return;
      if (inputId) inputId.value = v.id;
      if (precioEl) precioEl.textContent = formatea(v.price);
      if (boton) {
        if (v.available) { boton.removeAttribute("disabled"); boton.textContent = boton.getAttribute("data-label") || "Añadir al carrito"; }
        else { boton.setAttribute("disabled", "disabled"); boton.textContent = boton.getAttribute("data-agotado") || "Agotado"; }
      }
    }
    selects.forEach(function (s) { s.addEventListener("change", actualiza); });
    actualiza();
  }

  /* ---------- Botones de compra directa: añadir (con cantidad) y saltar al pago ---------- */
  function initComprarDirecto() {
    var botones = document.querySelectorAll("[data-mt-comprar]");
    if (!botones.length) return;
    botones.forEach(function (btn) {
      var form = btn.closest("form");
      if (!form) return;
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var idInput = form.querySelector("[name=id]");
        var id = idInput && idInput.value;
        if (!id) { form.submit(); return; }
        var qtyInput = form.querySelector("[name=quantity]");
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (qty < 1) qty = 1;
        var original = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = "Un momento…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: Number(id), quantity: qty })
        })
          .then(function (r) { return r.ok; })
          .then(function (ok) {
            if (ok) { window.location.href = "/checkout"; }
            else { btn.disabled = false; btn.innerHTML = original; window.location.href = "/cart"; }
          })
          .catch(function () { btn.disabled = false; btn.innerHTML = original; form.submit(); });
      });
    });
  }

  /* ---------- FAQ: cerrar los demás al abrir uno ---------- */
  function initFaq() {
    var items = document.querySelectorAll("[data-mt-faq] .mt-faq__item");
    if (!items.length) return;
    items.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;
        items.forEach(function (o) { if (o !== item) o.open = false; });
      });
    });
  }

  /* ---------- Reseñas: duplicar la pista para bucle infinito ---------- */
  function initMarquesina() {
    if (reduce) return;
    var pistas = document.querySelectorAll("[data-mt-marquesina]");
    if (!pistas.length) return;
    pistas.forEach(function (pista) {
      if (pista.children.length < 2) return;
      var originales = Array.prototype.slice.call(pista.children);
      originales.forEach(function (nodo) {
        var clon = nodo.cloneNode(true);
        clon.setAttribute("aria-hidden", "true");
        pista.appendChild(clon);
      });
    });
  }

  /* ---------- Cifras animadas (count-up) ---------- */
  function initContadores() {
    var nums = document.querySelectorAll("[data-mt-contador]");
    if (!nums.length || reduce || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-mt-contador"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var fin = parseFloat(el.getAttribute("data-mt-contador")) || 0;
        var suf = el.getAttribute("data-mt-sufijo") || "";
        var ini = performance.now();
        var dur = 1400;
        function paso(t) {
          var p = Math.min((t - ini) / dur, 1);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = (fin % 1 ? (fin * e).toFixed(1) : Math.round(fin * e)).toLocaleString("es-MX") + suf;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMarquesina();
    initReveal();
    initHeroParallax();
    initGaleria();
    initVariantes();
    initComprarDirecto();
    initFaq();
    initContadores();
  });
})();
